var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "usp-page applicant" }, [
    _c(
      "main",
      [
        _c(
          "b-container",
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { lg: "6" } }, [
                  _c("h1", [_vm._v("Dein Job findet dich.")]),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "\n\t\t\t\t\t\tskilldoo ist deine anonyme Jobmatching Plattform."
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\tAufgrund deiner Wünsche und Skills sucht skilldoo automatisiert nach dem Best-Match.\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mobile-avatar-button-container" }, [
                    _c(
                      "div",
                      [
                        _c("Avatar", {
                          attrs: { avatar: _vm.avatarCatNotebook }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "anonym" }, [
                          _c("img", {
                            attrs: { src: "/img/anonym.svg", alt: "Anonym" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("Button", {
                          attrs: {
                            text: "Passenden Job finden!",
                            icon: "caret-right",
                            href: "/kandidat"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t\tDas funktioniert ungefähr so wie bei einer Dating-App."
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\tDadurch erhältst du nur Job-Vorschläge, die wirklich gut zu dir passen.\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "button-container" },
                    [
                      _c("Button", {
                        attrs: {
                          text: "Passenden Job finden!",
                          icon: "caret-right",
                          href: "/kandidat"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "button-container" },
                    [
                      _c("Button", {
                        attrs: {
                          text: "Passende Mitarbeiter finden!",
                          secondary: "",
                          icon: "caret-right",
                          href: "/mitarbeiterfinden"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "feature-rows" }, [
                    _c(
                      "div",
                      { staticClass: "feature-row left-first" },
                      [
                        _c("Feature", {
                          attrs: {
                            icon: "homepage-register-once",
                            title: "Nur 1 Mal bewerben?",
                            text:
                              "Mit wenigen Klicks deine Wünsche und Skills eintragen.<br/>Und dein Job findet dich.",
                            color: "gold"
                          }
                        }),
                        _vm._v(" "),
                        _c("Feature", {
                          attrs: {
                            icon: "homepage-chat",
                            title: "Antwortgarantie?",
                            text: "Du erhältst regelmäßig Informationen.",
                            color: "yellow"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { lg: "6" } }, [
                  _c(
                    "div",
                    { staticClass: "avatar-container" },
                    [
                      _c("Avatar", {
                        attrs: { avatar: _vm.avatarCatNotebook }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "anonym" }, [
                        _c("img", {
                          attrs: { src: "/img/anonym.svg", alt: "Anonym" }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "feature-rows right" }, [
                    _c(
                      "div",
                      { staticClass: "feature-row first" },
                      [
                        _c("Feature", {
                          attrs: {
                            icon: "homepage-free",
                            title: "Kostenlos?",
                            text: "Für BewerberInnen ist skilldoo kostenlos!",
                            color: "lime"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "feature-row second" },
                      [
                        _c("Feature", {
                          attrs: {
                            icon: "homepage-anonymous",
                            title: "Anonym?",
                            text:
                              "Das Best-Match-System ist anonym. Du enscheidest, wer deine Daten bekommt.",
                            color: "turquoise"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "feature-row third" },
                      [
                        _c("Feature", {
                          attrs: {
                            icon: "homepage-vita",
                            title: "Ohne Lebenslauf und Bewerbungsschreiben?",
                            text:
                              "Du kannst einen Lebenslauf hochladen, musst aber nicht.",
                            color: "purple"
                          }
                        }),
                        _vm._v(" "),
                        _c("Feature", {
                          attrs: {
                            icon: "homepage-matching",
                            title: "Best-Match-System?",
                            text:
                              "skilldoo findet gezielt die passenden Jobs.<br/>Durch Balken wird die Übereinstimmung übersichtlich angezeigt.",
                            color: "lime"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c("h3", [_vm._v("So funktioniert's:")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("Schneller und einfacher zum passenden Job.")
                ]),
                _vm._v(" "),
                _c("HowItWorks", {
                  staticClass: "mt-4",
                  attrs: { type: "application" }
                }),
                _vm._v(" "),
                _c("ApplicantBenefits", { staticClass: "mt-5" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4 text-center" },
                  [
                    _c("Button", {
                      attrs: {
                        icon: "caret-right",
                        text: "Passenden Job finden!",
                        href: "/kandidat"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-none d-md-block mt-4 text-center" },
                  [
                    _c("Button", {
                      attrs: {
                        secondary: "",
                        icon: "caret-right",
                        text: "Passende Mitarbeiter finden!",
                        href: "/mitarbeiterfinden"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }